module.exports = __webpack_public_path__ + "img/calculator-card-pictures-6.27798f7e.jpg";